"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// ----------------------------------------------------------------------
function Tooltip(theme) {
    const isLight = theme.palette.mode === 'light';
    return {
        MuiTooltip: {
            styleOverrides: {
                popper: {
                    zIndex: 2000000001,
                },
                tooltip: {
                    backgroundColor: theme.palette.grey[isLight ? 800 : 700],
                },
                arrow: {
                    color: theme.palette.grey[isLight ? 800 : 700],
                },
            },
        },
    };
}
exports.default = Tooltip;
